export const SANR_DISCORD = 'https://discord.gg/YtqHEYEYTF';
export const MAILTO_KORZHIK = 'mailto:dmitry.k@santiment.net';
